import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'
import Whisper, { WhisperProps } from 'rsuite/Whisper'
import Popover from 'rsuite/Popover'
import { useFeatureIsOn } from '@growthbook/growthbook-react'

import useIsOnMobile from '../../services/useIsOnMobile'
import { ScreenSize } from '../../utils/constants'

import styles from '../../styles/TakeRateInfoPopover.module.less'

interface TakeRateInfoPopoverProps {
  children: WhisperProps['children']
}

const TakeRateInfoPopover: FC<TakeRateInfoPopoverProps> = (props) => {
  const { children } = props

  const { t } = useTranslation('products')
  const isOnMobile = useIsOnMobile(ScreenSize.md)
  const isTakeRateEnabled = useFeatureIsOn('consumption-based-take-rate')
  const placement = isOnMobile ? 'auto' : 'topEnd'

  if (!isTakeRateEnabled || !children) {
    return null
  }

  return (
    <Whisper
      trigger={isOnMobile ? 'click' : 'hover'}
      placement={placement}
      enterable
      rootClose
      speaker={(
        <Popover
          arrow={!isOnMobile}
          className={`${styles.popover}`}
        >
          <p>
            {t('Watch your prices decrease in real time as you add products to your cart or as your team spends more at Droppe')}
          </p>
        </Popover>
      )}
    >
      {children}
    </Whisper>
  )
}

export default TakeRateInfoPopover
